export default "__VITE_PUBLIC_ASSET__0899d666__"